import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { TENANCY_REPORTING_API_URL } from 'config';

const baseQuery = fetchBaseQuery({
    baseUrl: TENANCY_REPORTING_API_URL,
    prepareHeaders: (headers) => {
        let token = localStorage.getItem('reportAccessKey');

        const user = localStorage.getItem('user');

        if (user && token) {
            headers.set('authorization', `${token.slice(1, -1)}`)
        }
        return headers
    },
    credentials: "omit"
})

export const tenancyReportingApi = createApi({
    reducerPath: "tenancyReportingApi",
    baseQuery,
    endpoints: (builder) => ({
        getReportingData: builder.query({
            query: ({ extended }) => `user?extended=${extended}`,
            transformResponse: (response) => response,
            transformErrorResponse: (response) => response.status.query(),
            providesTags: (result) => {
                // is result available?
                return result
                    ? // successful query
                    [...result.map(({ id }) => ({ type: "UserReportingData", id })), { type: "UserReportingData", id: "LIST" }]
                    : // an error occurred, but we still want to refetch this query when `{ type: "Posts", id: "LIST" }` is invalidated
                    [{ type: "UserReportingData", id: "LIST" }];
            }
        })
    }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
    useGetReportingDataQuery,
} = tenancyReportingApi;
